import { GET_POPULAR_LIVE } from '../sagas/actions';
var initialState = [];
export default function balance(state, action) {
    if (state === void 0) { state = initialState; }
    if (action === void 0) { action = {}; }
    switch (action.type) {
        case GET_POPULAR_LIVE.SUCCESS:
            if (action.data && action.data.Error === undefined && action.data.message === undefined) {
                return action.data;
            }
            return state;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/popularLive.js